/**
 * @fileoverview Utilitário responsável por aplicar o comportamento padrão global dos toasts.
 */

import { toast } from "react-toastify";

// Define default behavior for all toasts (success, error, info, warn, default)
const BASE_OPTIONS = {
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  pauseOnFocusLoss: false,
  draggable: false,
  theme: "light",
};

const patchWithDefaults = () => {
  if (toast.__patchedWithDefaults) return;

  const applyDefaults = originalFn => (message, options = {}) => {
    const merged = { ...BASE_OPTIONS, ...options };
    const timeout = typeof merged.autoClose === "number" ? merged.autoClose : BASE_OPTIONS.autoClose;
    const toastId = originalFn(message, merged);

    // Extra safety: force dismiss shortly after the expected timeout
    if (timeout !== false) {
      setTimeout(() => toast.dismiss(toastId), timeout + 200);
    }

    return toastId;
  };

  const originals = {
    success: toast.success.bind(toast),
    error: toast.error.bind(toast),
    info: toast.info.bind(toast),
    warn: toast.warn.bind(toast),
  };

  toast.success = applyDefaults(originals.success);
  toast.error = applyDefaults(originals.error);
  toast.info = applyDefaults(originals.info);
  toast.warn = applyDefaults(originals.warn);
  toast.__patchedWithDefaults = true;
};

patchWithDefaults();

export default toast;
